import { LOGIN, LOGOUT, SET_PORTAL, SET_USER_ID } from "./authTypes";
import { clearTokens } from "../../utility/interceptors/axiosInstance";

const initialState = {
  id: "",
  email: "",
  username: "",
  fullName: "",
  roles: [],
  currentPortal :""
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
      return { ...initialState, ...action.payload }; 

    case LOGOUT:
      clearTokens();
      return initialState;

    case SET_USER_ID:
      return { ...state, userId: action.payload };
    
     case SET_PORTAL:
      return {
        ...state,
        currentPortal: action.payload,
      };

    default:
      return state;
  }
};

export default authReducer;
